import Box from "@mui/material/Box";
import { ProjectSectionProps } from "../type";
import { Typography } from "@mui/material";
import ActionButtons from "../action-buttons";
import RichTextDisplayer from "../../../atoms/rich-text-editor/RichTextDisplayer";
import { hasRealText } from "../../../utils/hasRealText";


export default function ProjectSection({
  projectId,
  invitationId,
  goToNextStep,
  projectData
}: ProjectSectionProps) {

  return (
    <Box sx={{ mt: 3 }}>
      {projectData ? (
        <Box>
          <Typography
            sx={{
              fontSize: { xs: "16px", sm: "18px", md: "20px" },
              fontWeight: "600",
              color: "#252B3B",
            }}
          >
            {projectData.topic}
          </Typography>
          {!projectData.description || !hasRealText(projectData.description) ? (
            <></>
          ) : (
            <RichTextDisplayer style={{fontSize:'15px', fontWeight: 500}} text={projectData.description} />
          )}

          <Typography sx={{ mt: 1 }}>
            Please confirm your interest in participating by accepting this invite. We'll be happy to share further details upon receiving confirmation from your end. Please note that this is a preliminary step and not a confirmation of the engagement. Upon accepting, you can review the project details & timelines, and then choose to participate/opt-out.
            <br></br>
            <br></br>
            Please refrain from discussing any confidential, proprietary and any material non-public information/ un-published price sensitive information during the call. To gain a clear understanding of the guidelines and rules for this engagement, we encourage you to revisit the expert tutorial and the agreement. Infollion, along with its client, retains the right to record the call for reference in the context of this project. By accepting this assignment, you are implicitly granting consent for the call to be recorded.
          </Typography>
          <ActionButtons
            invitationId={invitationId}
            submitLabel="Next"
            onSubmit={goToNextStep}
          />
        </Box>
      ) : null}
    </Box>
  );
}
